import React, { PureComponent } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import EditActionComponent from '../common/EditActionComponent'
import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import { hasAccess } from '../../utils/api'

export default class MemberProfileItem extends PureComponent {
  state = {
    location: null,
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      const value = isCheckBox ? event.target.checked : event.target.value

      this.props.onChange(key, value)
    }

  onSave = (region) => {
    this.props.onSave(() => this.props.disableEdit())
  }

  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data)
  }

  render() {
    const { data = {}, editMode = false } = this.props

    return (
      <TableRow>
        <TableCell>
          <EditableTextField
            valueToRender={data.name}
            editMode={false}
            value={data.name}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={data.required ? 'Enabled' : 'Disabled'}
            checked={data.required}
            editMode={editMode}
            onChange={this.onChange('required', true)}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell>
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.props.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MemberProfile/MemberProfileItem.js